import { withStyles } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CloseIcon from '@material-ui/icons/Close'
import cn from 'classnames'
import React from 'react'
import styles from './styles'
const Popup = ({
  classes,
  title,
  body,
  footer,
  onCancel,
  modalClassName,
  showCross = false,
  showBack = false,
  canBeClose = true,
  backHandler,
}) => {
  return (
    <div className={classes.modalWrapper}>
      <div
        className={classes.backdropFilter}
        onClick={e => {
          if (canBeClose) {
            e.stopPropagation()
            onCancel()
          }
        }}
      />
      <div
        className={
          modalClassName ? cn(classes.modal, modalClassName) : classes.modal
        }
      >
        {showCross && canBeClose ? (
          <div
            className={classes.cross}
            onClick={e => {
              e.stopPropagation()
              onCancel()
            }}
          >
            <CloseIcon />
          </div>
        ) : null}
        {showBack && canBeClose ? (
          <div className={classes.back} onClick={backHandler}>
            <ArrowBackIcon />
          </div>
        ) : null}
        <p className={classes.header}>{title}</p>
        <div className={classes.body}>{body}</div>
        <div className={classes.footer}>{footer}</div>
      </div>
    </div>
  )
}

export default withStyles(styles)(Popup)
